import React from 'react';

const InsuranceServices = () => {
  return (
    <div id="solutions" className="bg-navy-light">
      <div className="container mx-auto p-8 py-24">
        {/* Section Title and Description */}
        <div className="text-center mb-12">
          <h2 className="text-base font-semibold tracking-wide text-gold mb-2">What We Broker</h2>
          <p className="font-serif text-4xl font-semibold text-navy-dark mb-4">Our Services</p>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We work with Belize's leading insurers to source and compare coverage, helping you find the policy that's right for you.
          </p>
        </div>

        {/* Insurance Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 border border-gray-300 divide-y md:divide-y-0 md:divide-x divide-gray-300 bg-white">

          {/* Card 1 - Commercial Insurance */}
          <div className="p-8">
            <p className="text-xs font-semibold uppercase tracking-widest text-gold mb-2">Business</p>
            <h3 className="font-serif text-2xl font-semibold text-navy-dark mb-4">Commercial Insurance</h3>
            <ul className="text-gray-700 space-y-2 border-t border-gray-200 pt-4 list-disc list-inside">
              <li>Motor</li>
              <li>Property</li>
              <li>Liability</li>
              <li>Business Interruption</li>
              <li>Workers' Compensation</li>
            </ul>
          </div>

          {/* Card 2 - Home Insurance */}
          <div className="p-8">
            <p className="text-xs font-semibold uppercase tracking-widest text-gold mb-2">Property</p>
            <h3 className="font-serif text-2xl font-semibold text-navy-dark mb-4">Home Insurance</h3>
            <ul className="text-gray-700 space-y-2 border-t border-gray-200 pt-4 list-disc list-inside">
              <li>Property</li>
              <li>Contents</li>
              <li>Fire & Allied Perils</li>
              <li>Hurricane & Flood</li>
              <li>Personal Liability</li>
            </ul>
          </div>

          {/* Card 3 - Personal Insurance */}
          <div className="p-8">
            <p className="text-xs font-semibold uppercase tracking-widest text-gold mb-2">Individual</p>
            <h3 className="font-serif text-2xl font-semibold text-navy-dark mb-4">Personal Insurance</h3>
            <ul className="text-gray-700 space-y-2 border-t border-gray-200 pt-4 list-disc list-inside">
              <li>Motor</li>
              <li>Life</li>
              <li>Health</li>
              <li>Travel</li>
              <li>Personal Accident</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
}

export default InsuranceServices;
